var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecretIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#F7F8DE;stroke-width:4;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#F7F8DE;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#F7F8DE;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.7,63.85c-0.01,33.88-27.48,61.35-61.36,61.34c-26.5,0-44.14-18.67-45.88-20.63 c-2.73-3.07-16.08-18.73-15.46-40.73C3.8,35.5,27.6,2.48,64.36,2.49C98.24,2.49,125.7,29.97,125.7,63.85z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.91,103.78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.04,100.46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.08,104.96"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.43,102.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.12,121.28"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.85,124.54c-0.23-13.08,0.28-18.51,0.9-20.81c0.08-0.31,0.37-1.34,0.11-2.59c-0.47-2.23-2.44-3.97-4.39-4.72 c-1.83-0.71-3.5-0.52-4.39-0.34"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.4,107.78c2.32-21.83,2.7-33.2,3.15-38.7c0-0.05,0.56-5.85,1.01-12.04c0.26-3.63-1.53-4.96-2.59-5.74 c-1.96-1.45-4.88-1.53-6.86-0.34c-2.29,1.37-2.93,4.16-3.26,5.96c-1.9,10.26-2.21,33.56-2.25,36.67"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.47,85.28c-0.33-0.13-3.43-1.25-6.19,0.56c-2.4,1.58-3.53,4.72-2.7,7.76"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.8,88.31c-0.14-0.09-3.08-1.93-6.07-0.45c-2.35,1.16-3.7,3.86-3.26,6.64"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.23,90.56c-0.43-0.28-1.68-1.02-3.38-0.9c-2.44,0.17-3.84,1.96-4.05,2.25"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.8,6.75c-0.91,2-2.1,5.09-2.7,9c-0.98,6.39,0.72,7.77-0.22,11.02c-2.51,8.63-17.3,8.67-17.55,14.18 c-0.19,4.12,7.99,6.17,7.42,10.58c-0.45,3.52-5.98,4.68-5.62,7.42c0.33,2.51,5.15,2.88,5.4,5.17c0.23,2.13-5.68,2.58-6.08,5.4 c-0.22,1.6,1.48,2.24,2.7,4.72c2.17,4.43-0.8,7.41,0.45,9.9c2.54,5.07,17.4-2.03,28.8,3.38c4.51,2.14,9.49,6.71,13.05,16.88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecretIcon);
export default __webpack_public_path__ + "static/media/secret-icon.506d666714bd2186757ce2310fd95278.svg";
export { ForwardRef as ReactComponent };